import {skipToken} from '@reduxjs/toolkit/query';

import {
  GetAuctionVehicleCountApiArg,
  GetSourcingVehicleCountApiArg,
  useGetSourcingAuctionCountQuery,
  useSourcingGetVehicleCountQuery,
} from '@dms/api/core';

import {REAL_TIME_POLLING_INTERVAL} from '../../../constants/REAL_TIME_POLLING_INTERVAL';
import {SourcingType} from '../../../hooks/useSourcingType';

interface FilterCountOptions {
  classifieds: GetSourcingVehicleCountApiArg | typeof skipToken;
  auctions: GetAuctionVehicleCountApiArg | typeof skipToken;
  source: SourcingType;
  isPending: boolean;
  isInvalid: boolean;
  isRealTime: boolean;
}

export function useFilterCount(options: FilterCountOptions) {
  const classifieds = useSourcingGetVehicleCountQuery(options.classifieds, {
    pollingInterval: options.isRealTime ? REAL_TIME_POLLING_INTERVAL : undefined,
    skipPollingIfUnfocused: true,
    refetchOnFocus: options.isRealTime,
    skip: options.source === SourcingType.AUCTIONS || options.isInvalid,
  });
  const auctions = useGetSourcingAuctionCountQuery(options.auctions, {
    skip: options.source === SourcingType.CLASSIFIEDS || options.isInvalid,
  });
  const query = options.source === SourcingType.CLASSIFIEDS ? classifieds : auctions;
  const isLoading = query.isFetching || options.isPending;
  const count =
    isLoading || options.isInvalid || query.isError ? undefined : query.currentData?.count;
  return {
    count,
    isLoading,
    isError: query.isError,
    isUnavailable: count === undefined,
    refetch: query.refetch,
  };
}
